<template>
  <v-app id="gordijnen-page">
    <Menu />

    <v-container id="gordijnen" grid-list-lg>
      <v-layout row wrap>
        <!-- Gordijnen Block -->
        <v-flex xs12>
          <v-form ref="phaseOne" @submit.prevent="goToPhaseTwo">
            <v-card class="card-expansion">
              <v-toolbar @click="phaseOne" class='elevation-0'
                :class="stepOne + stepOneActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepOne + stepOneActive ? require('../assets/ui-elements/step1-active.png') : require('../assets/ui-elements/step1.png')"
                  alt="">
                <v-card-title dark> <span :class="stepOne + stepOneActive ? 'step-tile-active' : 'step-title'">Type
                    Stof</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 activeProductTitle">{{gordijnen || ''}}</h4>
                <v-icon :class="stepOne + stepOneActive  ? 'step-icon-active' : ''">{{toggleIcon(stepOne)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepOne">
                  <v-container grid-list-xs>
                    <v-layout row wrap>

                      <!-- Type Stof -->
                      <v-flex text-xs-center xs12 sm4>
                        <div class="product-tile" :class="gordijnen == 'Overgordijnen' ? 'selected' : '' ">
                          <label class="radio-container">
                            <input v-model="gordijnen" @click="inputChecked" type="radio" name="Overgordijnen"
                              value="Overgordijnen" required>
                            <img class="gordijnen-product-image pt-3 ml-4"   src="../assets/gordijnen/Lichtdoorlatend.png"
                              alt="">
                            <span class="checkmark"></span>
                          </label>

                        </div>
                        <h4 class="mt-2 product-tile-title">Overgordijnen</h4>
                      </v-flex>

                      <v-flex text-xs-center xs12 sm4>
                        <div class="product-tile" :class="gordijnen == 'In between' ? 'selected' : '' ">
                          <label class="radio-container">
                            <input v-model="gordijnen" @click="inputChecked" type="radio" name="inbetween"
                              value="In between" required>
                            <img class="gordijnen-product-image pt-3 ml-4" src="../assets/gordijnen/Transparant.png"
                              alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 product-tile-title">In between</h4>
                      </v-flex>

                      <v-flex v-if="error" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>

                      <v-flex mt-5 xs12>
                        <span>Stofmaat:</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-radio-group v-model="stofmaat" :rules="fabricRules" required>
                          <v-radio label="Breedte: 1400mm" value="breedte"></v-radio>
                          <v-radio label="Kamerhoog: 3200mm" value="hoogte"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Afmetingen hoogte Block -->
        <v-flex xs12 v-if="stofmaat == 'hoogte'">
          <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle"> B {{stofmaathoogteWidth}} mm x H
                  {{stofmaathoogteHeight}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>

                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="stofmaathoogteWidth"
                          :max="stofmaatMaxWith" required></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{stofmaatMaxWith}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="stofmaathoogteWidth" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="stofmaathoogteHeight"
                          :max="stofmaathoogteMaxHeight" required></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{stofmaathoogteMaxHeight}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline ref="heightInput" v-model="stofmaathoogteHeight" type="number">
                          </v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="errorSizes" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>
                          Volgende stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>

                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Afmetingen breedte block -->
        <v-flex xs12 v-if="stofmaat == 'breedte'">
          <v-form ref="sizesBlock" @submit.prevent="goToPhaseThree">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0'
                :class="stepTwo + stepTwoActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo + stepTwoActive ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo + stepTwoActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 text-truncate activeProductTitle" v-if="stofmaatbreedteWidth || stofmaatbreedteHeight">B {{stofmaatbreedteWidth}} mm x H
                  {{stofmaatbreedteHeight}} mm</h4>
                <v-icon :class="stepTwo + stepTwoActive ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>

                    <v-layout row wrap>
                      <!-- Breedte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg12>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="stofmaatbreedteWidth" 
                          :max="stofmaatMaxWith" required></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{stofmaatMaxWith}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Breedte</span>
                        <div class="sizeRange">
                          <v-text-field outline v-model="stofmaatbreedteWidth" type="number"></v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>

                      <!-- Hoogte -->
                      <v-flex xs12 sm4 md3>
                        <v-layout id="height-help" row wrap>
                          <v-flex xs5 sm4 md5 lg3>
                            <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                          </v-flex>
                          <v-flex xs1 sm7 md2 lg3 text-xs-left>
                            <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="height" xs12 sm7 md8>
                        <v-slider @input="sliderInput" v-model="stofmaatbreedteHeight" 
                          :max="stofmaatMaxWith" required></v-slider>
                        <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                        <v-flex class="max" xs6 text-xs-right>Max {{stofmaatMaxWith}} mm</v-flex>
                      </v-flex>

                      <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                        <span class="info-height mr-2">Hoogte</span>
                        <div class="sizeRange">
                          <v-text-field outline ref="heightInput" v-model="stofmaatbreedteHeight" type="number">
                          </v-text-field>
                        </div> <span class="ml-2 info-height">mm</span>
                      </v-flex>


                      <v-flex v-if="errorSizes" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>
                          Volgende stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>

                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Prijs Block -->
        <v-flex xs12>
          <v-form @submit.prevent="goToPhaseFour" ref="price">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseThree" class='elevation-0'
                :class="stepThree + stepThreeActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepThree + stepThreeActive ? require('../assets/ui-elements/step3-active.png') : require('../assets/ui-elements/step3.png')"
                  alt="">
                <v-card-title dark> <span :class="stepThree + stepThreeActive ? 'step-tile-active' : 'step-title'">Prijs
                    van de
                    stof</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 activeProductTitle">&#8364; {{price}}</h4>
                <v-icon :class="stepThree + stepThreeActive ? 'step-icon-active' : ''">{{toggleIcon(stepThree)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepThree">
                  <v-container grid-list-xs>

                    <v-layout row wrap>
                      <span class="mt-4">&#8364;</span>
                      <v-flex ml-3 xs4 sm2 md2>
                        <v-text-field ref="priceInput" :rules="priceRules" class="price-input" outline type="number"
                          v-model="price" placeholder="0,00">
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>
                          Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>

                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Plooi Block -->
        <v-flex xs12>
          <v-form @submit.prevent="goToPhaseFive" ref="plooi">
            <v-card class="card-expansion">
              <v-toolbar @click="phaseFour" class='elevation-0'
                :class="stepFour + stepFourActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepFour + stepFourActive ? require('../assets/ui-elements/step4-active.png') : require('../assets/ui-elements/step4.png')"
                  alt="">
                <v-card-title dark> <span
                    :class="stepFour + stepFourActive ? 'step-tile-active' : 'step-title'">Plooi</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 activeProductTitle">{{plooi | formatPlooi}}</h4>
                <v-icon :class="stepFour + stepFourActive ? 'step-icon-active' : ''">{{toggleIcon(stepFour)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepFour">
                  <v-container grid-list-xs>

                    <v-layout row wrap>
                      <!-- Enkele Plooi -->
                      <v-flex text-xs-center xs12 sm4 md4>
                        <div class="sub-product-tile" :class="plooi == 'enkel' ? 'plooi-selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="plooi" type="radio" name="EnkelePlooi" value="enkel"
                              required>
                            <img class="plooi-product-image pt-3" src="../assets/gordijnen/Enkele_plooi.png" alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 subproduct-tile-title">Enkele Plooi</h4>
                      </v-flex>

                      <!-- Dubbele Plooi -->
                      <v-flex text-xs-center xs12 sm4 md4>
                        <div class="sub-product-tile" :class="plooi == 'dubbel' ? 'plooi-selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="plooi" type="radio" name="DubbelePlooi" value="dubbel"
                              required>
                            <img class="plooi-product-image pt-3" src="../assets/gordijnen/Dubbele_plooi.png" alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 subproduct-tile-title">Dubbele Plooi</h4>
                      </v-flex>

                      <!-- Wave -->
                      <v-flex text-xs-center xs12 sm4 md4>
                        <div class="sub-product-tile" :class="plooi == 'wave' ? 'plooi-selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="plooi" type="radio" name="Wave" value="wave" required>
                            <img class="plooi-product-image pt-3" src="../assets/gordijnen/wave.png" alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 subproduct-tile-title">Wave</h4>
                      </v-flex>

                      <!-- Enkele Plooi Retour -->
                      <v-flex text-xs-center xs12 sm4 md4>
                        <div class="sub-product-tile" :class="plooi == 'enkel-retour' ? 'plooi-selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="plooi" type="radio" name="EnkelePlooiRetour"
                              value="enkel-retour" required>
                            <img class="plooi-product-image pt-3" src="../assets/gordijnen/Enkele_plooi_retour.png"
                              alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 subproduct-tile-title">Enkele Plooi Retour</h4>
                      </v-flex>

                      <!-- Dubbele Plooi Retour -->
                      <v-flex text-xs-center xs12 sm4 md4>
                        <div class="sub-product-tile" :class="plooi == 'dubbel-retour' ? 'plooi-selected' : '' ">
                          <label class="radio-container">
                            <input @click="inputChecked" v-model="plooi" type="radio" name="DubbelePlooiRetour"
                              value="dubbel-retour" required>
                            <img class="plooi-product-image pt-3" src="../assets/gordijnen/dubbele_plooi_retour.png"
                              alt="">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <h4 class="mt-2 subproduct-tile-title">Dubbele Plooi Retour</h4>
                      </v-flex>
                      <v-flex v-if="errorPlooi" xs12>
                        <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-btn type="submit" class="next-step text-none" color="primary" flat outline>
                          Volgende
                          stap <v-icon right>fal fa-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>

                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
          </v-form>
        </v-flex>

        <!-- Totaal Block -->
        <v-flex xs12>
          <v-form @submit.prevent="submitForm" ref="gordijnenForm" :no-validate="false" id="gordijnenForm">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseFive" class='elevation-0'
                :class="stepFive + stepFiveActive ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepFive + stepFiveActive ? require('../assets/ui-elements/step5-active.png') : require('../assets/ui-elements/step5.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepFive + stepFiveActive ? 'step-tile-active' : 'step-title'">Totaal</span>
                </v-card-title>
                <v-spacer></v-spacer>
                <h4 class="mr-5 activeProductTitle">&#8364;  {{totalPrice | currency}}</h4>
                <v-icon :class="stepFive + stepFiveActive ? 'step-icon-active' : ''">{{toggleIcon(stepFive)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepFive">
                  <v-container grid-list-xs>
                    <v-layout row wrap>

                      <!-- Type stof -->
                      <v-flex xs4 sm2 md2><span class="total-title">Type stof:</span></v-flex>
                      <v-flex xs8 sm10 md10><span class="total-item">{{gordijnen ||  ''}}</span>
                      </v-flex>

                      <!-- Afmetingen -->
                      <v-flex xs4 sm2 md2><span class="total-title">Afmeting:</span></v-flex>
                      <v-flex xs8 sm10 md10>
                        <span v-if="stofmaat == 'breedte'" class="total-item">Breedte {{stofmaatbreedteWidth}} mm
                          <strong>x</strong> Hoogte {{stofmaatbreedteHeight }} mm </span>
                        <span v-if="stofmaat == 'hoogte'" class="total-item">Breedte {{stofmaathoogteWidth}} mm
                          <strong>x</strong> Hoogte {{stofmaathoogteHeight }} mm </span>
                      </v-flex>

                      <!-- Prijs -->
                      <v-flex xs4 sm2 md2><span class="total-title">Prijs van de stof:</span>
                      </v-flex>
                      <v-flex xs8 sm10 md10> <span class="total-item">&#8364;
                          {{price}}</span></v-flex>

                      <!-- Plooi -->
                      <v-flex xs4 sm2 md2><span class="total-title">Plooi:</span></v-flex>
                      <v-flex xs8 sm10 md10> <span class="total-item">{{plooi | formatPlooi}}</span>
                      </v-flex>

                      <!-- Ruimte/Raam + Totale Prijs & Button -->
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4 sm2 md2><span class="total-title">Aantal</span></v-flex>
                          <v-flex xs6 sm10 md10>
                            <v-text-field class="quantity-input" v-model="quantity" type="number" :rules='quantityRules'
                              outline>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <span class="total-title">Ruimte / raam</span>
                          </v-flex>
                          <v-flex xs8 sm8 md8>
                            <v-text-field class='price-input' v-model="room" type="text" outline
                              label="Typ hier een naam voor de ruimte of het raam">
                            </v-text-field>
                          </v-flex>
                          <v-flex text-xs-center xs12>
                            <hr class="seperator-line">
                          </v-flex>
                          <v-flex xs2 text-xs-left>
                            <span class="end-total-title">Totaal</span>
                          </v-flex>
                          <v-flex xs10 text-xs-right>
                            <h2 class="price-total"> <span class="price-title mr-3">Prijs compleet,
                                incl. BTW </span> €
                              {{totalPrice | currency}}</h2>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
            <v-flex id="col-btn" xs12 text-xs-right>
              <v-btn type="submit" color="primary" depressed class="text-none form-btn">Plaats op lijst
                <v-icon class="icon-size" right>fal fa-plus</v-icon>
              </v-btn>
            </v-flex>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>

    <SnackBar v-model="snackbar" :text="messageTxt" :color="color" />
  </v-app>
</template>


<script>
import Menu from '@/components/Menu'; // Menu
import Messages from '@/services/messages.service'; // Meldingen
import SnackBar from '@/components/SnackBar'; // Meldingen venster
import ApiService from '@/services/api.service'; // Api Service
import FormatService from '@/services/format.service';

export default {
  components: {
    Menu,
    SnackBar
  },
  data() {
    return {
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepFive: false,
      stepOneActive: false,
      stepTwoActive: false,
      stepThreeActive: false,
      stepFourActive: false,
      stepFiveActive: false,
      snackbar: false,
      messageTxt: '',
      color: '',
      stofmaatbreedteHeight: null,
      stofmaatbreedteWidth: null,
      stofmaathoogteHeight: null,
      stofmaathoogteWidth: null,
      stofmaatMin: 250,
      stofmaatMaxWith: 10000,
      stofmaatMaxHeight: 10000,
      stofmaathoogteMaxHeight: 3200,
      price: null,
      gordijnen: 'Overgordijnen',
      plooi: 0,
      stofmaat: 'breedte',
      quantity: 1,
      room: '',
      productPrijs: 0,
      error: false,
      errorPlooi: false,
      errorSizes: false,
      errorMsg: '',
      fabricRules: [rules => !!rules || Messages.FabricValdationMessage],
      priceRules: [price => !!price || Messages.PriceValidationMessage],
      quantityRules: [quantity => !!quantity || Messages.QuantityValidationMessage]
    }
  },
  computed: {
    totalPrice() {
      return this.quantity * this.productPrijs
    },

  },
  methods: {
    getWidthPrice() {
     if(this.stofmaatbreedteWidth > 249 && this.stofmaatbreedteHeight > 249 && this.price !== null){
        ApiService.getCurtainsPrice({
          stoftype: this.stofmaat,
          hoogte: this.stofmaatbreedteHeight,
          breedte: this.stofmaatbreedteWidth,
          stofprijs: this.price,
          plooi: this.plooi
        }).then(response => {
          this.productPrijs = response;
        })
     }
    },

     getHeightPrice() {
     if(this.stofmaathoogteWidth > 249 && this.stofmaathoogteHeight > 249 && this.price !== null){
        ApiService.getCurtainsPrice({
          stoftype: this.stofmaat,
          hoogte: this.stofmaathoogteHeight,
          breedte: this.stofmaathoogteWidth,
          stofprijs: this.price,
          plooi: this.plooi
        }).then(response => {
          this.productPrijs = response;
        })
     }
    },
    phaseOne() {
      this.stepOne = !this.stepOne;
    },
    phaseTwo() {
      this.stepTwo = !this.stepTwo;
    },
    phaseThree() {
      this.stepThree = !this.stepThree;
    },
    phaseFour() {
      this.stepFour = !this.stepFour;
    },
    phaseFive() {
      this.stepFive = !this.stepFive;
    },
    goToPhaseTwo(e) {
      if (e.target.elements.Overgordijnen.validity.valid ||
        e.target.elements.inbetween.validity.valid) {
        this.$nextTick(() => {
          if (this.$refs.phaseOne.validate()) {
            this.stepOne = false;
            this.stepTwo = true;
            this.stepOneActive = true;
            this.error = false;
          if(this.stofmaat == 'breedte'){
            this.getWidthPrice();
          }

          if(this.stofmaat == 'hoogte'){
               this.getHeightPrice();
          }
          }
        })
      } else {
        this.$refs.phaseOne.validate()
        this.error = true;
        this.errorMsg = Messages.TypeValidationMessage;
      }
    },
    goToPhaseThree() {
      if (this.stofmaat == 'hoogte') {
          if(this.stofmaathoogteHeight > 249 && this.stofmaathoogteWidth > 249){
            this.stepOne = false;
          this.stepTwo = false;
          this.stepTwoActive = true;
          this.stepThree = true;
             this.getHeightPrice();
          }else {
          this.errorSizes = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
        
      }

      if (this.stofmaat == 'breedte') {
  
         if(this.stofmaatbreedteHeight > 249 && this.stofmaatbreedteWidth > 249){
            this.stepOne = false;
          this.stepTwo = false;
          this.stepTwoActive = true;
          this.stepThree = true;
         this.getWidthPrice();
         }else {
          this.errorSizes = true;
          this.errorMsg = Messages.SizesValidationMessage;
        }
        
      } 

    },
    goToPhaseFour() {
      if (this.$refs.price.validate()) {
        this.stepOne = false;
        this.stepTwo = false;
        this.stepThree = false;
        this.stepThreeActive = true;
        this.stepFour = true;
        if(this.stofmaat == 'hoogte'){
        this.getHeightPrice()
        }

        if(this.stofmaat == 'breedte'){
        this.getWidthPrice()
        }
      }
    },
    goToPhaseFive(e) {
      if (
        e.target.elements.EnkelePlooi.validity.valid ||
        e.target.elements.DubbelePlooi.validity.valid ||
        e.target.elements.Wave.validity.valid ||
        e.target.elements.EnkelePlooiRetour.validity.valid ||
        e.target.elements.DubbelePlooiRetour.validity.valid) {
        this.stepOne = false;
        this.stepTwo = false;
        this.stepThree = false;
        this.stepFour = false;
        this.stepFourActive = true;
        this.stepFive = true;
        this.stepFiveActive = true;
      this.getWidthPrice()
        this.getHeightPrice()
      } else {
        this.errorPlooi = true;
        this.errorMsg = Messages.FoldValdationMessage
      }
    },
    submitForm() {
      if (this.$refs.gordijnenForm.validate()) {
        this.stepFive = false;
        this.stepOneActive = false;
        this.stepTwoActive = false;
        this.stepThreeActive = false;
        this.stepFourActive = false;
        this.stepFiveActive = false;
        this.snackbar = true;
        this.color = '#006fb3';
        this.messageTxt = Messages.ProductAddedMessage;
 if(this.stofmaat == 'breedte'){
          this.$store.dispatch('products/addProduct', {
          naam: this.$router.history.current.name,
          product: this.gordijnen,
          stoftype: this.stofmaat,
          breedte: this.stofmaatbreedteWidth, 
          hoogte: this.stofmaatbreedteHeight,
          stofprijs: this.price,
          plooi: this.plooi,
          hoeveelheid: this.quantity,
          ruimte: this.room,
          totaleprijs: this.quantity * this.productPrijs
        })
 }

 if(this.stofmaat == 'hoogte'){
          this.$store.dispatch('products/addProduct', {
          naam: this.$router.history.current.name,
          product: this.gordijnen,
          stoftype: this.stofmaat,
          breedte: this.stofmaathoogteWidth, 
          hoogte: this.stofmaathoogteHeight,
          stofprijs: this.price,
          plooi: this.plooi,
          hoeveelheid: this.quantity,
          ruimte: this.room,
          totaleprijs: this.quantity * this.productPrijs
        })

 }

      } else {
        this.snackbar = true;
        this.color = '#FF5252';
        this.messageTxt = Messages.NoProductsMessage;
      }
    },
    toggleIcon(value) {
      if (value) {
        return 'fal fa-minus-circle';
      } else {
        return 'fal fa-plus-circle';
      }
    },
    inputChecked(e) {
      if (e.target.validity.valid) {
        this.error = false;
        this.errorPlooi = false;

        if(this.stofmaat == 'breedte'){
          this.getWidthPrice();
        }
        if(this.stofmaat == 'hoogte'){
          this.getHeightPrice()
        }
      }
    },
    sliderInput(value) {
      if (value > 249) {
        this.error = false;
               this.errorSizes = false;
      }
    }
  },
  filters: {
    ...FormatService
  }
}
</script>

<style scoped>
#gordijnen-page {
  background-color: #fff;
}

.stofmaat-item {
  font-weight: 700;
}

.card-expansion {
  box-shadow: none;
  border: 1px solid #eaeaea;
}

.min {
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
  top: 0;
  left: 0;
  left: -5%;
  top: -15%;
  color: #b4b4b4;
  font-size: 12px;
  font-weight: 400;
}

.max {
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
  clear: both;
  right: -55%;
  top: -34%;
  color: #b4b4b4;
  font-size: 12px;
  font-weight: 400;
}

.sizeRange {
  border-radius: 4px;
  display: inline-block;
  width: 120px;
  height: 60px;
  position: relative;
  top: -1em;
  padding: 1em;
  vertical-align: middle;
  line-height: 60px;
}

.info-height {
  color: #707070;
  font-size: 16px;
  font-weight: 400;
}

.size-unit {
  position: relative;
  top: -3em;
  line-height: 30px;
  text-align: center;
}

.product-panel {
  border-top: 3px solid #b4b4b4;
  background-color: #fff;
}

.panel-open {
  border-top: 3px solid #006fb3;
  background-color: #fff;
}

.step-title {
  font-size: 15px;
  font-weight: 700;
  color: #b4b4b4;
}

.step-tile-active {
  font-size: 15px;
  font-weight: 700;
  color: #006fb3;
}

.step-icon-active {
  color: #006fb3;
}

.next-step {
  border-radius: 4px;
  height: 60px;
}

.activeProductTitle {
  color: #b4b4b4;
  font-size: 16px;
  font-weight: 400;
}

.product-tile {
  border: 1px solid #d0d0d0;
}

.product-tile-title {
  font-weight: 400;
  font-size: 19px;
  color: #707070;
}


.end-total-title {
    font-size: 15px;
    color: #006fb3;
    font-weight: 700;
}

.gordijnen-product-image {
  position: relative;
  right: 10px;
}

.selected {
  border: 2px solid #006fb3;
}

.plooi-selected {
  border: 2px solid #006fb3 !important;
}

.seperator-line {
  border: 1px solid #b4b4b4;
}

.gordijnen-product-image {
  width: 35%;
}

.plooi-product-image {
  width: 50%;
}

.sub-product-tile {
  border: 1px solid #eaeaea;
}

.subproduct-tile-title {
  color: #707070;
  font-size: 18px;
  font-weight: 400;
}

.total-title {
  color: #006fb3;
  font-size: 13px;
  font-weight: 700;
}

.price-title {
  color: #006fb3;
  font-size: 13px;
  font-weight: 700;
}


.total-item {
  color: #707070;
  font-size: 13px;
  font-weight: 400;
}

.price-total {
  font-size: 15px;
  color: #006fb3;
  font-weight: 700;
}

.form-btn {
  border-radius: 4px;
  height: 60px;
  margin: 0 !important;
  width: 180px;
}

.icon-size {
  font-size: 20px;
}

#col-btn {
  padding-right: 0;
  padding-left: 0;
}

@media screen and (max-width: 1024px) {
  .gordijnen-product-image {
    width: 50%;
  }

  .plooi-product-image {
    width: 80%;
  }
}

@media screen and (max-width: 425px) {
  .size-unit {
    position: relative;
    top: -2.5em;
  }

  .form-btn {
    width: 100%;
  }

  #height-help {
    margin: 0 auto;
    text-align: center;
    justify-content: center;
  }

  .info-height {
    font-size: 13px;
  }

  .activeProductTitle {
    font-size: 14px;
  }

}

@media screen and (max-width: 320px) {
  .size-unit {
    position: relative;
    top: -3em;
  }

  .activeProductTitle {
    display: none;
  }

}
</style>
